import { OnsiteInjectionDto } from "@intelligems/ig-types/dtos/onsite-injections";
import { VariationDto } from "@intelligems/ig-types/dtos/variations";

export const getOnsiteInjectionsFromExperienceDto = (
  variations: VariationDto[]
) => {
  const tempInjections: OnsiteInjectionDto[] = [];
  for (const variation of variations) {
    if (variation.onsiteInjections?.id) {
      tempInjections.push({
        variationId: variation.id,
        customCss: variation.onsiteInjections.customCss ?? undefined,
        customJs: variation.onsiteInjections.customJs ?? undefined,
        id: variation.onsiteInjections.id,
        jsInjectionMode: variation.onsiteInjections.jsInjectionMode ?? {
          type: "immediately",
        },
      });
    }
  }
  return tempInjections;
};
